'use client';

import * as React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/shared/ui/tabs';
import { RecentMeetingsStrip } from './RecentMeetingsStrip';

/**
 * The dedicated "My meetings" page's two tabs — Upcoming (scheduled/live)
 * and Done (ended). `limit={0}` on each strip means the full history for
 * that tab, not the 3-row peek used elsewhere on /create.
 */
export function MyMeetingsTabs() {
  return (
    <Tabs defaultValue="upcoming">
      <TabsList variant="line" className="mb-4">
        <TabsTrigger variant="line" value="upcoming">
          Upcoming
        </TabsTrigger>
        <TabsTrigger variant="line" value="done">
          Done
        </TabsTrigger>
      </TabsList>

      <TabsContent value="upcoming">
        <RecentMeetingsStrip
          limit={0}
          statusFilter={['created', 'active']}
          label="Upcoming"
          emptyTitle="No upcoming meetings"
          emptyDescription="Meetings you schedule or start will show up here."
        />
      </TabsContent>

      <TabsContent value="done">
        <RecentMeetingsStrip
          limit={0}
          statusFilter={['ended', 'cancelled']}
          label="Done"
          emptyTitle="No meetings yet"
          emptyDescription="Meetings you've finished will show up here."
        />
      </TabsContent>
    </Tabs>
  );
}
